import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { eastOrangeConfig } from "./data";

export default function EastOrangePage() {
  return <CityPageTemplate config={eastOrangeConfig} />;
}